export default {"src":"/trader-new/_next/static/media/SwitchBusinesss.e86d9930.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};